import styled from '@emotion/styled';

const TitleMultipleQuotesStyle = styled('div')`
    .title-detail {
        padding: 36px 0;
        background: #152643;
    }
    .sub-title {
        font-weight: 500;
        color: rgb(102, 102, 102);
        background-color: #f2f2f2;
        font-size: 20px;
        padding: 22px 0;
    }
    .box-multiple-title {
        background: #152643;
        color: #fff;
        padding: 22px 0;

        .box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 10px;
            gap: 16px;

            .text-current {
                color: #93fce7;
                font-weight: 900;
                font-size: 20px;

                .icon-circle {
                    cursor: pointer;
                    font-size: 36px;
                    color: #12987e;
                    &.disabled {
                        cursor: not-allowed;
                        opacity: 0.65;
                    }
                }
            }
            .text-compare {
                font-weight: 700;
                cursor: pointer;
                text-align: right;
                font-size: 1.15rem;
                span {
                    text-decoration-line: underline;
                }
            }
        }
    }

    .sticky-active {
        padding-top: 114px;
        .box-multiple-title {
            width: 100%;
            position: fixed;
            left: 0;
            top: 0;
            z-index: 99;
        }
    }

    &.multiple {
        .title-detail {
        }

        .sub-title {
            font-size: 20px;
            padding: 22px 0;
        }
    }

    @media screen and (min-width: 1200px) {
        .box-multiple-title {
            .box {
                .text-compare {
                    font-size:21px;
                }
            }
        }
    }

    @media screen and (max-width: 767px) {
        .title-detail {
            padding: 18px 0;

            .sub-title {
                font-size: 20px;
            }
        }
    }

    @media screen and (max-width: 410px) {
        .box-multiple-title {
            .box {
                .text-current {
                    font-size: 18px;
                    white-space: nowrap;
                    .icon-circle {
                        font-size: 32px;
                    }
                }
                .text-compare {
                    font-size:16px;
                }
            }
        }
    }
`;

export default TitleMultipleQuotesStyle;
